export default function DesignerNotesCard({ notes, setNotes }) {
  return (
    <div className="border border-black bg-white p-6 md:p-8" data-testid="designer-form">
      <div className="overline text-zinc-500 mb-2">DESIGNER · OBSERVAÇÕES GERAIS</div>
      <h2 className="font-head text-2xl font-bold mb-6">Configurar Produção</h2>

      <div className="border border-yellow-500 bg-yellow-50 p-3 mb-6 text-xs">
        <strong>Silk color, imagem da arte e observações</strong> agora são configurados <strong>por item</strong> na seção "Itens do Pedido" acima. Cada item pode ter sua própria cor de silk, arte e instruções específicas.
      </div>

      <div>
        <label className="label">Observações Gerais do Pedido</label>
        <textarea className="input min-h-[90px]" value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Instruções gerais válidas para o pedido inteiro..." data-testid="general-notes" />
        <p className="text-[11px] text-zinc-500 mt-1">Para observações específicas de um item, use o campo dentro de cada item acima.</p>
      </div>
    </div>
  );
}
